import { render, staticRenderFns } from "./social-cat-ad.vue?vue&type=template&id=ea6b8e88&scoped=true&"
import script from "./social-cat-ad.vue?vue&type=script&lang=js&"
export * from "./social-cat-ad.vue?vue&type=script&lang=js&"
import style0 from "./social-cat-ad.vue?vue&type=style&index=0&id=ea6b8e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6b8e88",
  null
  
)

export default component.exports